'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { breakLabel } from '../../../utils/labelUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import LabelInput from './LabelInput';
export default class DescriptorBlock extends Component {
  render() {
    const {
      description,
      id,
      isAdditionalProperty,
      label,
      onKeyChange,
      required,
      schema,
      schemaGroup,
      schemaTypeI18nKey
    } = this.props;
    const tOptions = {
      defaultValue: schema.format || schema.type
    };
    const wideLabel = (schema.type || '') === 'object';
    return /*#__PURE__*/_jsx("div", {
      className: !wideLabel ? 'params-descriptor-wrapper' : "",
      children: /*#__PURE__*/_jsxs("div", {
        className: "params-descriptor",
        children: [/*#__PURE__*/_jsxs(UIFormLabel, {
          "aria-describedby": description && `${id}-description`,
          className: 'p-all-0' + (isAdditionalProperty && required ? " is-additional-property-label" : ""),
          htmlFor: id,
          required: required,
          children: [label && !isAdditionalProperty && breakLabel(label), isAdditionalProperty && /*#__PURE__*/_jsx(LabelInput, {
            label: label,
            onKeyChange: onKeyChange
          })]
        }), schema.type && schemaTypeI18nKey && /*#__PURE__*/_jsx(Small, {
          use: "help",
          className: "display-block",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: schemaTypeI18nKey,
            options: tOptions
          })
        }), schemaGroup && /*#__PURE__*/_jsx(Small, {
          use: "help",
          className: "display-block",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-shared-components.params.body.schemaGroup.${schemaGroup.replace(' ', '')}`,
            options: {
              defaultValue: schemaGroup
            }
          })
        })]
      })
    });
  }

}
DescriptorBlock.propTypes = {
  description: PropTypes.string,
  id: PropTypes.string.isRequired,
  isAdditionalProperty: PropTypes.bool,
  label: PropTypes.string,
  onKeyChange: PropTypes.func,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string,
  schemaTypeI18nKey: PropTypes.string
};
DescriptorBlock.defaultProps = {
  isAdditionalProperty: false
};